import { Resource } from './resource';

export class CvSubmit extends Resource {
    cvSubmitted: string;
    cvShortListed: string;
    jdId: string;
    jdName: string;
    recruiterId: string;
    recruiterName: string;
    submitDate: string;
}
